﻿import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import classes from "../maintainers.module.scss";
import { hasPermission } from "@/services/Utils";

import { ReactComponent as PencilSvg } from "@/assets/images/desktop/editar.svg";
import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";

const OperatorsTableBody = ({ handleDelete, permissions }) => {
	const navigate = useNavigate();

	const { operators } = useSelector((state) => state.maintainers_operators);

	return (
		<tbody>
			{operators &&
				operators.map((item, i) => {
					return (
						<tr className={`${classes.table_tr}`} key={i}>
							<td className={`${classes.table_td} ${classes.first_td}`}>
								<div className={`${classes.table_div}  ${classes.first_div}`}>{i + 1}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div}`}>{item.name}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center} ${classes.column}`}>
									{item.estates_parents && item.estates_parents.length > 0 ? (
										item.estates_parents.map((estate_parent, k) => <span key={k}>{estate_parent.name}</span>)
									) : (
										<span></span>
									)}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center} ${classes.column}`}>
									{item.estates && item.estates.length > 0 ? (
										item.estates.map((estate, k) => <span key={k}>{estate.name}</span>)
									) : (
										<span></span>
									)}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center} ${classes.column}`}>
									{item.categories && item.categories.length > 0 ? (
										item.categories.map((category, k) => <span key={k}>{category.name}</span>)
									) : (
										<span></span>
									)}
								</div>
							</td>

							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div}  ${classes.last_div}`}>
									{hasPermission("edit", permissions) && (
										<PencilSvg className={classes.icon} onClick={() => navigate("/configuracion/operadores/editar/" + item.slug)} />
									)}

									{hasPermission("delete", permissions) && <RemoveSvg className={classes.icon} onClick={() => handleDelete(item)} />}
								</div>
							</td>
						</tr>
					);
				})}
		</tbody>
	);
};

export default OperatorsTableBody;
